var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 18L16.5 21L22.5 15","stroke":"#D22128","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Checkmark.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
